import * as amplitude from '@amplitude/analytics-browser';
import { environment } from 'src/environments/environment';
import { TokenUsuario } from 'src/app/shared/models/login-response';

export function initAmplitude() {
  amplitude.init(environment.amplitudeApiKey, {
    autocapture: {
      elementInteractions: true,
      pageViews: true,
      sessions: true,
      fileDownloads: true,
      formInteractions: true,
    },
    minIdLength: 1,
  });
}

// Group type usado no Group Analytics do Amplitude para agrupar eventos
// por empresa/cliente (contratante), além do agrupamento por usuário individual
const groupType = 'contratanteId';

export function identifyAmplitudeUser(usuario: TokenUsuario): void {
  if (!usuario?.id) {
    return;
  }

  amplitude.setUserId(String(usuario.id));

  const identifyEvent = new amplitude.Identify();
  identifyEvent.set('empresaId', usuario.empresaId);
  if (usuario.contratante?.id) {
    identifyEvent.set('contratanteId', usuario.contratante.id);
  }
  if (usuario.perfilIDs) {
    identifyEvent.set('perfilIDs', usuario.perfilIDs);
  }
  if (usuario.podeAcessarContratantes !== undefined) {
    identifyEvent.set('podeAcessarContratantes', usuario.podeAcessarContratantes);
  }
  if (usuario.contratante?.idCanalDeVenda !== undefined) {
    identifyEvent.set('idCanalDeVenda', usuario.contratante.idCanalDeVenda);
  }
  if (usuario.contratante?.situacaoProcessoCadastral) {
    identifyEvent.set('situacaoProcessoCadastral', usuario.contratante.situacaoProcessoCadastral);
  }
  amplitude.identify(identifyEvent);

  if (usuario.contratante?.id) {
    amplitude.setGroup(groupType, String(usuario.contratante.id));
  }
}

export function resetAmplitudeUser(): void {
  amplitude.reset();
}

export function trackAmplitudeEvent(eventName: string, eventProperties?: Record<string, unknown>): void {
  amplitude.track(eventName, eventProperties);
}

// Eventos do funil de onboarding/setup da contratante.
export const SETUP_STEP_COMPLETED_EVENT = 'Setup - Etapa concluída';
export const SETUP_COMPLETED_EVENT = 'Setup - Concluído';

// Eventos de negócio do Dashboard de Gestão (management-panel) e dos pop-ups de download em lote e justificativa em lote.
export const DASHBOARD_FILTRO_APLICADO_EVENT = 'dashboard_filtro_aplicado';
export const DASHBOARD_PROCESSOS_PARALISADOS_VISUALIZADO_EVENT = 'dashboard_processos_paralisados_visualizado';
export const DASHBOARD_OBRIGACOES_ATRASO_VISUALIZADO_EVENT = 'dashboard_obrigacoes_atraso_visualizado';
export const DASHBOARD_OBRIGACOES_NO_PRAZO_VISUALIZADO_EVENT = 'dashboard_obrigacoes_no_prazo_visualizado';
export const DASHBOARD_OBRIGACOES_ENTREGUES_OU_NAO_CONTEMPLADAS_VISUALIZADO_EVENT = 'dashboard_obrigacoes_entregues_ou_nao_contempladas_visualizado';
export const DASHBOARD_GRAFICOS_ATUALIZADO_EVENT = 'dashboard_graficos_atualizado';
export const PAINEL_GERENCIAL_CLASSIFICACAO_ENTREGAS_VISUALIZADO_EVENT = 'painel_gerencial_classificacao_entregas_visualizado';
export const PAINEL_GERENCIAL_OBRIGACOES_PRAZO_VISUALIZADO_EVENT = 'painel_gerencial_obrigacoes_prazo_visualizado';
export const CERTIFICADOS_VENCIMENTO_VENCIDOS_VISUALIZADO_EVENT = 'certificados_vencimento_vencidos_visualizado';
export const CERTIFICADOS_VENCIMENTO_30DIAS_VISUALIZADO_EVENT = 'certificados_vencimento_30dias_visualizado';
export const CERTIFICADOS_VENCIMENTO_60DIAS_VISUALIZADO_EVENT = 'certificados_vencimento_60dias_visualizado';
export const DIRETORIOS_MONITORADOS_VISUALIZADO_EVENT = 'diretorios_monitorados_visualizado';
export const CONSUMO_LICENCAS_VISUALIZADO_EVENT = 'consumo_licencas_visualizado';
export const DOWNLOAD_LOTE_POPUP_ABERTO_EVENT = 'download_lote_popup_aberto';
export const DOWNLOAD_LOTE_OPCAO_SELECIONADA_EVENT = 'download_lote_opcao_selecionada';
export const DOWNLOAD_LOTE_CONFIRMADO_EVENT = 'download_lote_confirmado';
export const JUSTIFICATIVA_LOTE_POPUP_ABERTO_EVENT = 'justificativa_lote_popup_aberto';
export const JUSTIFICATIVA_LOTE_FILTRO_APLICADO_EVENT = 'justificativa_lote_filtro_aplicado';
